import styled from 'styled-components';
import {
  rootFontSize,
} from '../../cssVariables';
import {
  gridSmallMediaSize,
  searchBarHeight as searchBarHeighLarge,
  searchBarHeightSmall,
  searchBottomToSectionNavTopHeight,
  sectionNavTopToGraphControlsTopHeight as sectionNavTopToGraphControlsTopHeightLarge,
  sectionNavTopToGraphControlsTopHeightSmall,
  sideBarContentWidth,
  sideBarContentWidthSmall,
  smallMediaQuery,
} from '../Grid';
import {
  primaryColor2,
} from '../Utils';

export const GridRoot = styled.div`
  display: grid;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
`;
export const SlidePreviousContainer = styled.div`
  grid-column: 1;
  grid-row: 1/2;
`;
export const ContentContainer = styled.div`
  grid-column: 1;
  grid-row: 2/3;
`;
export const SlideAdvanceContainer = styled.div`
  grid-column: 1;
  grid-row: 3;
`;
// Assume that the browser's native scrollbar is never wider than 20px:
export const slideContentWidth = sideBarContentWidth * rootFontSize;
export const slideContentWidthSmall = sideBarContentWidthSmall * rootFontSize;
export const getSidebarHeight = () => {
  const searchBarHeight = window.innerHeight > gridSmallMediaSize ? searchBarHeighLarge : searchBarHeightSmall;
  const sectionNavTopToGraphControlsTopHeight = window.innerHeight > gridSmallMediaSize
        ? sectionNavTopToGraphControlsTopHeightLarge : sectionNavTopToGraphControlsTopHeightSmall;
  return window.innerHeight - rootFontSize * (
    searchBarHeight +
    searchBottomToSectionNavTopHeight +
    sectionNavTopToGraphControlsTopHeight
  );
};

export const Title = styled.div`
  margin: 1rem 0;
  color: ${primaryColor2};
  font-size: 1.5rem;
  line-height: 1.4;

  @media ${smallMediaQuery} {
    font-size: 1rem;
    margin: 0.7rem 0;
  }
`;

export const IntroText = styled.div`
  margin-bottom: 1rem;
  color: #666;
  line-height: 1.5;
  text-align: justify;
  hyphens: auto;

  @media ${smallMediaQuery} {
    font-size: 0.8rem;
    line-height: 1.3;
  }
`;
/* tslint:disable */
// tslint is disabled to prevent the base64
// url from exceeding the max line length 
export const HighlightedText = styled.span`
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAKElEQVQYV2NkQAP+ySt9GZHFQAIb54ZvhgvCBECKwILIAmBBdAGQIAArdRGufgJuUAAAAABJRU5ErkJggg==) repeat;
  color: #666;
  padding: 0.08rem 0.25rem;
  white-space: pre-wrap;
  border-radius: 4px;
`;
/* tslint:enable */
